/* global window */
import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import theme, { buttonReset } from '../../styles/theme';
import { ribbonShape } from '../../propTypes';

const Ribbon = ({
  classes, className, color, text, url,
}) => {
  const Tag = url ? 'button' : 'span';
  // can't use <a href> because we will nest this inside the <a> rendered by Product
  const extraProps = url ? {
    type: 'button',
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = url;
    },
  } : {};
  return (
    <Tag
      className={cn(className, classes.ribbon, url && classes.clickable)}
      style={{ color }}
      {...extraProps}
    >
      {text}
    </Tag>
  );
};

Ribbon.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  ...ribbonShape,
};

Ribbon.defaultProps = {
  className: undefined,
};

export default injectSheet({
  ribbon: {
    ...buttonReset({
      fontFamily: theme.fonts.bold,
      fontWeight: theme.fonts.boldWeight,
      letterSpacing: '0.07em',
      fontSize: '0.9em',
      textTransform: 'uppercase',
      textDecoration: 'none',
      verticalAlign: 'middle',
    }),
  },
  clickable: {
    cursor: 'pointer',
  },
})(Ribbon);
